export const ROW_GUTTER = 16;
export const SIDE_NAV_WIDTH = 220;
export const SIDE_NAV_COLLAPSED_WIDTH = 80;
export const SIDE_NAV_LIGHT = "SIDE_NAV_LIGHT";
export const SIDE_NAV_DARK = "SIDE_NAV_DARK";
export const NAV_TYPE_SIDE = "SIDE";
export const NAV_TYPE_TOP = "TOP";
export const DIR_LTR = "ltr";
export const DIR_RTL = "rtl";
export const AVATAR_COLOR = "#d2ab66";

export const THEME_COLORS = {
  red: {
    50: "#FF6B721A",
    90: "#FEF2F2",
    100: "#FFF1F0",
    500: "#DC2626",
  },
  yellow: {
    50: "#FFC5421A",
    90: "#FFF7ED",
    100: "#FFF6D1",
    400: "#FFC542",
    600: "#8F7D06",
  },
  green: {
    90: "#F0FDF4",
    100: "#E6FFFB",
    500: "#2CA87F",
    600: "#08979C",
  },
  blue: {
    50: "#3E79F733",
    90: "#EFF6FF",
    500: "#4680FF",
  },
  gray: {
    50: "#72849AB2",
    80: "#F9FAFB",
    100: "#F4F4F5",
    300: "#999999",
    400: "#6B7280",
    500: "#72849A",
  },
  white: {
    100: "#F5F5F5",
  },
  chart: {
    colors1: ["#ffc658", "#8dd1e1", "#82ca9d", "#d084d0", "#ff9c6e"],
    colors2: ["#4680FF", "#2CA87F", "#FFC542", "#DC2626", "#722ed1"],
  },
};
